import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { createAuthorizationHeader } from '../../utils/headers';
import { DateInterval } from 'src/app/model/date-interval.model';
import { Path, Overspeed, Stop, Mileage } from 'src/app/model/historical';
import { GlobalService } from 'src/app/global.config';
import { DataManagementService } from '../data-management/data-management.service';
import { ToastController } from '@ionic/angular';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { version } from '../../global.config';

@Injectable({
  providedIn: 'root'
})
export class HistoricalService {

  pathModal: any;

  paths: Path[] = new Array();

  overspeeds: Overspeed[] = new Array();

  stops: Stop[] = new Array();

  mileages: Mileage[] = new Array();
  startDate: Date = new Date();

  endDate: Date = new Date();

  selectedTab: String;
  loading: boolean;
  version: string;
  pathsLoadedForDeviceId: number | null = null;
  stopsLoadedForDeviceId: number | null = null;
  mileagesLoadedForDeviceId: number | null = null;
  overspeedsLoadedForDeviceId: number | null = null;

  constructor(private _http: HttpClient,
    private globalService: GlobalService,
    public dataManagementService: DataManagementService,
    public geocodingService: GeocodingService,
    public toastr: ToastController,) {
    this.endDate.setHours(23, 59, 59, 0);
    this.startDate.setTime(this.startDate.getTime() - 3 * 86400000);
    this.startDate.setHours(0, 0, 0, 0);

    this.selectedTab = "path";
    this.version = version;
  }

  getCurrentPath(deviceId: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "paths/currentPath/" + deviceId, null, { headers: headers });
  }

  getAllPaths(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "paths/" + deviceId, dateInterval, { headers: headers });
  }
  getPathDetails(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "paths/details/" + deviceId, dateInterval, { headers: headers });
  }

  getAllStops(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "stops/" + deviceId, dateInterval, { headers: headers });
  }

  getAllOverspeeds(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "rep_overspeed/" + deviceId, dateInterval, { headers: headers });
  }

  getOverspeedDetails(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "rep_overspeed/details/" + deviceId, dateInterval, {
        headers: headers
      });
  }

  getAllMileages(deviceId: number, dateInterval: any): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "mileage/" + deviceId, dateInterval, { headers: headers });
  }

  /**
   * Sort historique list items newest-first for UI lists
   * (trajets, arrêts, kilométrage, excès de vitesse).
   */
  sortByDateDesc<T>(
    items: T[] | null | undefined,
    getDate: (item: T) => Date | string | number | null | undefined
  ): T[] {
    if (!items?.length) {
      return items || [];
    }
    return [...items].sort((a, b) => this.toTimeMs(getDate(b)) - this.toTimeMs(getDate(a)));
  }

  private toTimeMs(value: Date | string | number | null | undefined): number {
    if (value == null || value === '') {
      return 0;
    }
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }
    const t = value instanceof Date ? value.getTime() : new Date(value).getTime();
    return Number.isFinite(t) ? t : 0;
  }

  getMileageDetails(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "mileage/details/" + deviceId, dateInterval, {
        headers: headers
      });
  }

  getTodaysMileage(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + "mileage/todayDetails/" + deviceId, dateInterval, {
        headers: headers
      });
  }

  getAllPathRoutine() {
    const vehicle = this.dataManagementService.ensureSelectedVehicle();
    const deviceId = this.dataManagementService.getSelectedDeviceId();
    if (!vehicle || !deviceId) {
      this.paths = [];
      this.pathsLoadedForDeviceId = null;
      this.loading = false;
      return;
    }

    this.pathsLoadedForDeviceId = deviceId;
    this.loading = true
    this.paths = [];
    this
      .getAllPaths(deviceId, {
        startDate: this.startDate,
        endDate: this.endDate
      })
      .subscribe(
        paths => {
          this.loading = false
          if (paths.length) {
            this.paths = this.sortByDateDesc(paths, p => p.beginPathTime);
            this.dataManagementService.selectedGroup = this.dataManagementService.selectedGroup;
            this.dataManagementService.selectedVehicule = vehicle;
            //let lastLat = paths[0].beginPathLatitude;
            //let lastlng = paths[0].beginPathLongitude;
            let i = 0;

            if (this.paths.length && this.paths[0].endPathLatitude == null && this.paths[0].endPathLongitude == null) {//current path not finished
              if (vehicle.realTimeRecord && vehicle.realTimeRecord.validity/* && !vehicle.realTimeRecord.ignition*/) {
                this.paths[0].endPathLatitude = vehicle.realTimeRecord.coordinate.lat;
                this.paths[0].endPathLongitude = vehicle.realTimeRecord.coordinate.lng;
                this.paths[0].endPathTime = new Date(vehicle.realTimeRecord.recordTime);
              }
            }

            this.paths.forEach(path => {
              let startHour: any = path.beginPathTime;
              let startTime: any = startHour;
              path.pathDurationStr = this.transformTime(path.pathDuration)
              path.displayBeginPathTime = startTime;

              if (path.endPathTime != null) {
                let endHour: any = path.endPathTime;
                let endTime: any = endHour;
                path.displayEndPathTime = endTime;
              }

              path.beginPathGeocodingDetails = this.dataManagementService.getRelativePosition(
                path.beginPathLatitude,
                path.beginPathLongitude
              );
              path.beginPathGeocoding = path.beginPathGeocodingDetails;
              if (path.beginPathGeocodingDetails == null || path.beginPathGeocodingDetails == '') {
                this.geocodingService
                  .inverseGeoconding(
                    path.beginPathLatitude,
                    path.beginPathLongitude,
                    17
                  )
                  .subscribe(
                    adress => {
                      path.beginPathGeocoding = this.geocodingService.proccessingNomitamAddress(
                        adress
                      );
                      path.beginPathGeocodingDetails = this.geocodingService.proccessingNomitamAddress(
                        adress
                      );
                    },
                    err => {
                      path.beginPathGeocodingDetails = null;
                      path.beginPathGeocoding = null;
                    }
                  );
                // }
              }
              path.endPathGeocodingDetails = this.dataManagementService.getRelativePosition(
                path.endPathLatitude,
                path.endPathLongitude
              );
              path.endPathGeocoding = path.endPathGeocodingDetails;
              if (path.endPathGeocodingDetails == null || path.endPathGeocodingDetails == '') {
                this.geocodingService
                  .inverseGeoconding(
                    path.endPathLatitude,
                    path.endPathLongitude,
                    17
                  )
                  .subscribe(
                    adress => {
                      path.endPathGeocoding = this.geocodingService.proccessingNomitamAddress(
                        adress
                      );
                      path.endPathGeocodingDetails = this.geocodingService.proccessingNomitamAddress(
                        adress
                      );
                    },
                    err => {
                      path.endPathGeocodingDetails = null;
                      path.endPathGeocoding = null;
                    }
                  );
              }
              i++;
              //lastLat = path.beginPathLatitude;
              //lastlng = path.beginPathLongitude;
            });
          }
        },
        err => {
        }
      );
  }


  transformTime(time: any) {

    let sec = time % 60
    let min = Math.trunc(time / 60)
    let h = Math.trunc(min / 60)
    let j = Math.trunc(h / 24)

    if (j != 0) {
      return j + ' j ' + h + ' h ' + min + ' min ' + sec + ' sec'
    }
    if (j == 0 && h != 0) {
      return h + ' h ' + min + ' min ' + sec + ' sec'
    }
    if (j == 0 && h == 0 && min != 0) {
      return min + ' min ' + sec + ' sec'
    }
    if (j == 0 && h == 0 && min == 0) {
      return sec + ' sec'
    }
    return null;
  }


  getAllOverSpeedRoutine() {
    const vehicle = this.dataManagementService.ensureSelectedVehicle();
    const deviceId = this.dataManagementService.getSelectedDeviceId();
    if (!vehicle || !deviceId) {
      this.overspeeds = [];
      this.overspeedsLoadedForDeviceId = null;
      this.loading = false;
      return;
    }

    this.overspeedsLoadedForDeviceId = deviceId;
    this.loading = true
    let endDate = this.endDate;
    let startDate = this.startDate;
    this.getAllOverspeeds(deviceId, { startDate, endDate }).subscribe(
      overspeeds => {
        this.loading = false
        this.overspeeds = this.sortByDateDesc(overspeeds, o => o.beginPathTime)
        this.overspeeds.forEach(overspeed => {
          let startHour: any = overspeed.beginPathTime;
          let startTime: any = startHour;

          overspeed.displayBeginPathTime = startTime;
          let endHour: any = overspeed.endPathTime;
          let endTime: any = endHour;
          overspeed.displayEndPathTime = endTime;

          let date1: any = startHour;
          let date2: any = endHour;
          let diffInMs: number = date2 - date1;
          let diffInSec: number = diffInMs / 1000;
          let diffInMinute: number = Math.floor(diffInSec / 60);

          overspeed.pathDurationStr = diffInMinute + "m " + (diffInSec - 60 * diffInMinute) + "s";
          overspeed.beginPathGeocodingDetails = this.dataManagementService.getRelativePosition(
            overspeed.beginPathLatitude,
            overspeed.beginPathLongitude
          );
          overspeed.beginPathGeocoding = overspeed.beginPathGeocodingDetails;
          //if (overspeed.beginPathGeocodingDetails == null) {

          this.geocodingService
            .inverseGeoconding(
              overspeed.beginPathLatitude,
              overspeed.beginPathLongitude,
              17
            )
            .subscribe(
              adress => {
                overspeed.beginPathGeocoding = this.geocodingService.proccessingNomitamAddress(
                  adress
                );
                overspeed.beginPathGeocodingDetails = this.geocodingService.proccessingNomitamAddress(
                  adress
                );
              },
              err => {
                overspeed.beginPathGeocodingDetails = null;
                overspeed.beginPathGeocoding = null;
              }
            );

          //}
          overspeed.endPathGeocodingDetails = this.dataManagementService.getRelativePosition(
            overspeed.endPathLatitude,
            overspeed.endPathLongitude
          );
          overspeed.endPathGeocoding = overspeed.endPathGeocodingDetails;
          //if (overspeed.endPathGeocodingDetails == null) {
          this.geocodingService
            .inverseGeoconding(
              overspeed.endPathLatitude,
              overspeed.endPathLongitude,
              17
            )
            .subscribe(
              adress => {
                overspeed.endPathGeocoding = this.geocodingService.proccessingNomitamAddress(
                  adress
                );
                overspeed.endPathGeocodingDetails = this.geocodingService.proccessingNomitamAddress(
                  adress
                );
              },
              err => {
                overspeed.endPathGeocodingDetails = null;
                overspeed.endPathGeocoding = null;
              }
            );
          //}
        });
      }
    )

  }


}
